<script>
    import {IMAGE_MENU_HORIZONTAL} from '../const';
    import ImageControl from "./ImageHeader.svelte";
    import Menu from "./Menu.svelte";
    import BlockGlobal from "./BlockGlobal.svelte";

    export let data, onChange;

    let disable = ['blockGlobal'];
    if (data.type === IMAGE_MENU_HORIZONTAL) {
        disable.push('align');
    }

</script>
<ImageControl bind:data={data} onChange={onChange} disable={disable} isCollapsable={true}/>
<Menu bind:data={data} isCollapsable={true} isCollapsed={true}/>
<BlockGlobal bind:data={data} isCollapsable={true} isCollapsed={true}/>